module.exports = __webpack_public_path__ + "static/media/clipboard.4529fec0.png";